/**
 * assets/product-tabs-docs.js
 * Gedrag van sections/product-tabs.liquid, blok "Schema.org DigitalDocument"
 *
 * Hangt de handleiding en het productdocument als subjectOf onder de bestaande
 * Product-entity in de JSON-LD @graph. Eén Product-entity voorkomt
 * duplicate-entity-waarschuwingen in de Rich Results Test; daarom mergen we in
 * plaats van een tweede blok te renderen.
 *
 * De documenten zelf komen uit het JSON-eiland #pt-digital-documents.
 * Zie ARCHITECTURE.md sectie 11.
 */

(function () {
  'use strict';

  var el = document.getElementById('pt-digital-documents');
  if (!el) return;

  var docs;
  try { docs = JSON.parse(el.textContent); } catch (e) { return; }
  if (!docs || !docs.length) return;

  document.querySelectorAll('script[type="application/ld+json"]').forEach(function (node) {
    try {
      var d = JSON.parse(node.textContent);
      if (d['@graph']) {
        var p = d['@graph'].find(function (i) { return i['@type'] === 'Product'; });
        if (p) { p.subjectOf = (p.subjectOf || []).concat(docs); node.textContent = JSON.stringify(d); }
      }
    } catch (e) {}
  });
})();
